enum AppStatus {
  loading,
  isTma,
  isElse,
}

export default AppStatus
